import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Modal,
  Select,
  message,
} from 'antd'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { makeRequest } from 'api/apiv2'
import React from 'react'
import { MaskPattern } from 'utils'
import { MaskedInput } from 'antd-mask-input'

const AddNewVolunteerModal = ({ isOpen, handler, refreshList = null }) => {
  const [volunteerForm] = Form.useForm()
  const { organization } = useAuthSelector()
  const [loading, setLoading] = React.useState(false)

  const onFinish = (values) => {
    submitVolunteer(values)
  }

  const submitVolunteer = (body) => {
    const payload = {
      ...body,
      organizationId: organization?.id,
      organizationName: organization?.Name,
      phoneNumber: `${body?.countryCode}${body.phoneNumber?.replace(
        /\D/g,
        '',
      )}`,
    }
    delete payload.countryCode
    setLoading(true)

    makeRequest('post', `admin/volunteer-community`, {}, payload)
      .then(() => {
        message.success('Volunteer added successfully')
        if (refreshList) refreshList()
        handler(false)
        volunteerForm.resetFields()
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        if (error?.response?.status === 422) {
          const errorMessages = error?.response?.data?.error?.messages
          errorMessages.forEach((msg) => message.error(msg))
        } else {
          message.error(
            error?.response?.data?.error?.message ||
              'Error in adding volunteer',
          )
        }
      })
  }

  return (
    <Modal
      title="Add New Volunteer"
      visible={isOpen}
      onCancel={() => handler(false)}
      footer={null}
    >
      <Form form={volunteerForm} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[{ required: true, message: 'First name is required' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="lastName" label="Last Name">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="countryCode"
              label="Select Country"
              colon={false}
              rules={[{ required: true, message: 'Country code is required' }]}
            >
              <Select
                placeholder="Select Country Code"
                style={{ width: '100%' }}
              >
                <Select.Option value="+1">
                  United States/Canada (+1)
                </Select.Option>
                <Select.Option value="+54">Argentina (+54)</Select.Option>
                <Select.Option value="+92">Pakistan (+92)</Select.Option>
                <Select.Option value="+55">Brazil (+55)</Select.Option>
                <Select.Option value="+58">
                  Venezuela, Bolivarian Republic of Venezuela (+58)
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="phoneNumber"
              label="Phone Number"
              rules={[{ required: true, message: 'Phone number is required' }]}
            >
              <MaskedInput
                inputMode="numeric"
                mask={MaskPattern}
                onChange={(e) => {
                  volunteerForm.setFieldValue('phoneNumber', e.maskedValue)
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="email" label="Email">
              <Input type="email" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="state" label="State">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="skills" label="Skills">
              <Select mode="tags" placeholder="Enter skills">
                {/* Optional: populate with predefined options */}
              </Select>
            </Form.Item>
          </Col>
          <Divider />
          <Col span={24} className="text-right">
            <Button
              type="secondary"
              className="mx-5"
              onClick={() => handler(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="px-25"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default AddNewVolunteerModal
